import React from 'react';
import { Link } from 'gatsby';

import { Card, CardContent, CardTitle } from '../../ui/card';
import { RelatedPost } from '../../../lib/types/post.types';

type RelatedCardPostProps = {
  post: RelatedPost;
};

const RelatedCard = ({ post }: RelatedCardPostProps) => {

  return (
    <Card className='md:flex justify-start p-3 max-h-fit max-w-[45%] md:items-center hover:shadow-black dark:hover:shadow-white'>
      <CardContent className='p-0'>
        <Link to={`/${post.frontmatter.permalink}`}>
          <CardTitle className='inline-block font-medium text-lg mt-1'>
            {post.frontmatter.title}
          </CardTitle>
        </Link>
      </CardContent>
    </Card>
  );
};
export default RelatedCard;